document.addEventListener("DOMContentLoaded", (event) => {
var bannerSlider = new Swiper(".board__slider", {
  slidesPerView: 1,
loop: true,
  spaceBetween: 0,
  autoplay: {
    delay: 2000,
  },
});
var bannerSlider = new Swiper(".book-quote__slider", {
  slidesPerView: 1,
loop: true,
  spaceBetween: 0,
  autoplay: {
    delay: 3500,
  },
});
var bannerSlider = new Swiper(".banner__slider", {
  slidesPerView: 1,
  effect: "fade",
  spaceBetween: 0,
  autoplay: {
    delay: 1000,
  },
});
});

var swiperQuote = new Swiper(".product-quote__slider", {
  slidesPerView: 1,
  autoHeight: true,
  calculateHeight: true,
  effect: "fade",
  spaceBetween: 0,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  spaceBetween: 0,
  autoplay: {
    delay: 2000,
  },
});